import React from 'react';
import {Popup} from 'semantic-ui-react';

import {CopyTextIcon} from '@utils/CopyTextIcon';

export const showCopyableIdTooltip = (name, id, columnName) => (
    <Popup
        hoverable
        trigger={<span>{name}</span>}
        content={(
            <span className='--flex --alignCenter'>
                {`${columnName} ID: ${id}`}
                <CopyTextIcon value={String(id)}/>
            </span>
        )}
    />
);
